<script lang="ts">
import type { Snippet } from "svelte";

let {
  label,
  children,
  ariaLive,
}: {
  label: string;
  children: Snippet;
  ariaLive?: "off" | "polite" | "assertive";
} = $props();
</script>

<div
  class="flex items-baseline justify-between gap-4 text-sm"
  aria-live={ariaLive}
>
  <span class="text-muted-foreground">{label}</span>
  <span class="text-right font-medium">
    {@render children()}
  </span>
</div>
